import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TitleBarComponent } from 'src/app/base/shared/title-bar/title-bar.component';
import { VendorScoreCardAdministrationService } from './vendor-score-card-administration.service';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { CheckBoxModule } from '@syncfusion/ej2-angular-buttons';
import { CellEditArgs, CellSaveArgs, EditService, FilterService, GridModule, PageService, RowDataBoundEventArgs, SortService, ToolbarService } from '@syncfusion/ej2-angular-grids';
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { DataManager } from '@syncfusion/ej2-data';
import { VendorScoreCardRowTypeV20 } from 'src/app/base/models/models.swagger.generated';
import { ToolbarClickEventArgs } from '@syncfusion/ej2-angular-filemanager';
import { AvpCustomAdaptorBatch } from 'src/app/base/shared/syncfusion/avp-custom-adaptor-batch';
import { Subscription } from 'rxjs';
import { SyncfusionTranslationService } from 'src/app/base/services/syncfusion-translation.service';
import { DataBoundEventArgs } from '@syncfusion/ej2-angular-dropdowns';
import { VendorScoreCardOnePointReferenceName, VendorScoreCardRowTypeV20Name, VendorScoreCardTenPointsReferenceName, VendorScoreCardUtil, VendorScoreCardWeightedCatName, VendorScoreCardWeightedSubName } from '../../vendor-score-card-util';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-vendor-score-card-administration',
    templateUrl: './vendor-score-card-administration.component.html',
    styleUrls: ['./vendor-score-card-administration.component.scss'],
    imports: [TitleBarComponent, TranslateModule, GridModule, CheckBoxModule, ToolbarModule, TitleBarComponent],
    providers: [PageService, FilterService, ToolbarService, SortService, EditService]
})
export class VendorScoreCardAdministrationComponent extends GridBaseComponent<any> implements OnInit, OnDestroy {
  protected override initializeEditForm(data: any): void {
    throw new Error('Method not implemented.');
  }
  protected override getEditDialogTitleParams(rowData: any): object {
    throw new Error('Method not implemented.');
  }

  public customEditSettings = {
    allowEditing: true,
    allowAdding: false,
    allowDeleting: false,
    mode: 'Batch',
    showDeleteConfirmDialog: true
  };

  public columnRowType: string = VendorScoreCardRowTypeV20Name;
  public columnWeightedCat: string = VendorScoreCardWeightedCatName;
  public columnWeightedSub: string = VendorScoreCardWeightedSubName;
  public columnTenPointsReference: string = VendorScoreCardTenPointsReferenceName;
  public columnOnePointReference: string = VendorScoreCardOnePointReferenceName;

  public itemDisabled: boolean = true;

  public toolbarOptions = ['Update', 'Cancel'];

  public translationBase = "i18n.shared.vendor-score-card-row-types.";

  public numericCellValidationRules?: Object;

  public weightedCatSum: number = 0;

  public compareToMaxValue: (args: { [key: string]: number }) => boolean = (args: { [key: string]: number }) => {
    return (args['value'] <= 100);
  }

  public compareToMinValue: (args: { [key: string]: number }) => boolean = (args: { [key: string]: number }) => {
    return (args['value'] >= 0);
  }

  private subscriptions: Subscription = new Subscription();

  constructor(
    private vendorScoreCardAdministrationService: VendorScoreCardAdministrationService,
    translateService: TranslateService,
    private spinnerService: SpinnerService,
    private syncfusionTranslationService: SyncfusionTranslationService,
    private sanitizer: DomSanitizer
  ) {
    super(translateService, vendorScoreCardAdministrationService);
  }

  ngOnInit() {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptorBatch(this.vendorScoreCardAdministrationService, this.spinnerService),
    });

    this.numericCellValidationRules = {
      maxLength: [this.compareToMaxValue, ''],
      minLength: [this.compareToMinValue, '']
    };

    this.translateService.get('i18n.domain.vendor-score-card.messages.validation-max-value-message').subscribe((response) => {
      this.numericCellValidationRules['maxLength'][1] = response;
      this.numericCellValidationRules['minLength'][1] = this.translateService.instant('i18n.domain.vendor-score-card.messages.validation-min-value-message');
    });

    this.subscriptions.add(this.syncfusionTranslationService.onLanguageChanged.subscribe(() => {
      setTimeout(() => {
        if (this.numericCellValidationRules) {
          this.numericCellValidationRules['maxLength'][1] = this.translateService.instant('i18n.domain.vendor-score-card.messages.validation-max-value-message');;
          this.numericCellValidationRules['minLength'][1] = this.translateService.instant('i18n.domain.vendor-score-card.messages.validation-min-value-message');
        }
      }, 0);
    }));

    this.isActiveColumnName = 'active';
  }

  ngOnDestroy() {
    this.subscriptions?.unsubscribe();
  }

  public getRowTypeTranslationString(rowType: VendorScoreCardRowTypeV20): string {
    return this.translationBase + VendorScoreCardRowTypeV20[rowType].toString();
  }

  public getRowTypeHtml(rowType: VendorScoreCardRowTypeV20): SafeHtml {
    const html = this.translateService.instant(this.getRowTypeTranslationString(rowType));
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  public displayData(data: string, rowType: VendorScoreCardRowTypeV20, columnType: string): string | null {
    return VendorScoreCardUtil.displayData(data, rowType, columnType, true);
  }

  public cellEdit(args: CellEditArgs) {
    if (
      args.value === null ||
      (args.columnName == this.columnWeightedSub &&
        VendorScoreCardUtil.getCategoryHeaderRows().includes(args.rowData[this.columnRowType]))
    ) {
      args.cancel = true;
    }
  }

  private handleCellValueCalculations(rows: VendorScoreCardRowTypeV20[],
    rowType: VendorScoreCardRowTypeV20, columnType: string, editedCellValue: string) {

    var newValue = 0;
    var startRow = rows[0];
    var endRow = rows[rows.length - 1];

    for (var i = startRow; i <= endRow; i++) {
      if (rowType != i) {
        var value = VendorScoreCardUtil.extractCellValue(this.grid, i, this.grid?.getColumnByField(columnType).index);
        newValue = newValue + Number.parseInt(value);
      }
      else {
        newValue = newValue + Number.parseInt(editedCellValue);
      }
    }
    if (newValue > 100) {
      var difference = newValue - 100;
      this.grid.updateCell(rowType, columnType, Number.parseInt(editedCellValue) - difference);
      newValue = 100;
    }
    else {
      this.grid.updateCell(rowType, columnType, editedCellValue);
    }
    this.grid.updateCell(startRow - 1, columnType, newValue);
  }

  public clickHandler(args: ToolbarClickEventArgs): void {
    if (args.item.id.includes('update')) {
      if (!this.allRequiredRowsAreFilled()) {
        this.vendorScoreCardAdministrationService.toastService.showError('i18n.errors.server-error.title', 'i18n.domain.vendor-score-card.messages.validation-required-fields-message', null);
        args.cancel = true;
      }
    }
  }

  public onCellSaved(args: CellSaveArgs) {
    var rowType = args.rowData[this.columnRowType];
    var columnType = args.columnName;

    if (columnType == this.columnWeightedCat) {
      var sum = this.weightedCatSum - Number.parseInt(args.previousValue) + Number.parseInt(args.value);

      if (sum > 100) {
        var difference = sum - 100;
        this.weightedCatSum = 100;
        this.grid.updateCell(rowType, columnType, Number.parseInt(args.value) - difference);
      }
      else {
        this.weightedCatSum = sum;
        this.grid.updateCell(rowType, columnType, args.value);
      }
    }
    else if (columnType == this.columnWeightedSub) {
      VendorScoreCardUtil.getCategoryHeaderRows().forEach(headerRow => {
        var rowsForCategoryHeader = VendorScoreCardUtil.getRowsForCategoryHeader(headerRow);
        if (rowsForCategoryHeader.includes(rowType)) {
          this.handleCellValueCalculations(rowsForCategoryHeader, rowType, columnType, args.value);
        }
      });
    }
    else if (columnType == this.columnTenPointsReference || columnType == this.columnOnePointReference) {
      if (VendorScoreCardUtil.getCurrencyRowsAdmin().includes(rowType)) {
        if (Number.parseInt(args.value) < 0) {
          this.grid.updateCell(rowType, columnType, 0);
        }
      }
      else if (VendorScoreCardUtil.getPercentageRowsAdmin().includes(rowType)) {
        if (Number.parseInt(args.value) < 0) {
          this.grid.updateCell(rowType, columnType, 0);
        }
        else if (Number.parseInt(args.value) > 100) {
          this.grid.updateCell(rowType, columnType, 100);
        }
      }
    }
  }

  public onDataBound(args: DataBoundEventArgs) {
    var categoryHeaderRows = VendorScoreCardUtil.getCategoryHeaderRows();
    this.weightedCatSum = 0;
    categoryHeaderRows.forEach(row => {
      this.weightedCatSum += Number.parseInt(
        VendorScoreCardUtil.extractCellValue(this.grid, row, this.grid?.getColumnByField(this.columnWeightedCat)?.index));
    });
  }

  public onRowDataBound(args: RowDataBoundEventArgs) {
    VendorScoreCardUtil.addRowClasses(args);
  }

  private isRequiredRowFilled(row: VendorScoreCardRowTypeV20): boolean {
    if (
      VendorScoreCardUtil.extractCellValue(this.grid, row, this.grid.getColumnByField(this.columnWeightedSub).index) == "" ||
      VendorScoreCardUtil.extractCellValue(this.grid, row, this.grid.getColumnByField(this.columnTenPointsReference).index) == "" ||
      VendorScoreCardUtil.extractCellValue(this.grid, row, this.grid.getColumnByField(this.columnOnePointReference).index) == ""
    ) {
      return false;
    }
    return true;
  }

  private allRequiredRowsAreFilled() {
    var returnValue: boolean = true;

    VendorScoreCardUtil.getRequiredRows().forEach(row => {
      returnValue = returnValue && this.isRequiredRowFilled(row);
    });

    return returnValue;
  }
}
